/**
 * Flags the sticky add to cart bar (<product-quick-add>) as sold out while the selected variant is sold out,
 * so the bar can hide itself (setting: hide_fixed_add_to_cart_when_sold_out).
 *
 * Availability comes from `allVariantInventoryLevels` (snippets/inventory-levels.liquid), the same source the
 * buy buttons use, so each market's stock rule applies (AU counts e-store stock only). It is read directly rather
 * than from the buy button's disabled state, because apps can re-enable that button after the theme disables it.
 */
class QuickAddAvailability extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }

  connectedCallback() {
    this._quickAdd = this.closest('.product-quick-add');
    this._productForm = document.forms[this.getAttribute('form')];
    this._productForm?.addEventListener('variant:change', this._onVariantChangedListener);

    const variantId = this._productForm?.elements.id?.value;
    if (variantId) {
      this._update(this._isAvailable(variantId, true));
    }
  }

  disconnectedCallback() {
    this._productForm?.removeEventListener('variant:change', this._onVariantChangedListener);
  }

  _onVariantChanged(event) {
    const variant = event.detail.variant;
    this._update(variant ? this._isAvailable(variant.id, variant.available) : false);
  }

  _isAvailable(variantId, fallback) {
    return window.allVariantInventoryLevels?.[variantId]?.available ?? fallback;
  }

  _update(available) {
    this._quickAdd?.classList.toggle('product-quick-add--sold-out', !available);
  }
}

if (!window.customElements.get('quick-add-availability')) {
  window.customElements.define('quick-add-availability', QuickAddAvailability);
}
